import * as React from "react";
import { Datagrid, TextField, RichTextField } from "react-admin";
import { PbhStatusUpdateExcelHeader, PbhStatusUpdateExcelName, TitlePbhStatusUpdate } from "./PbhStatusUpdateConstant";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";
import CreatedByField from "../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { SourceVwUser } from "../../../../Constants/Source";
import { Box, ButtonGroup, Grid, IconButton, Tooltip } from "@material-ui/core";
import { Backup } from "@material-ui/icons";
import PbhStatusUpdateUploadFile from "./PbhStatusUpdateUploadFile";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType } from "../../../../Enums/FilterTypes";
import { htmlToPlainText } from "../../../../Helper/HtmlToText";

const PbhStatusUpdateList = props => {
  const [selectedItemRequestId, setSelectedItemRequestId] = React.useState(0);
  const [isUploadFileDialogOpen, setIsUploadFileDialogOpen] = React.useState(false);
  const handleFileDialogClose = () => setIsUploadFileDialogOpen(false);
  const handleFileDialogOpen = () => setIsUploadFileDialogOpen(true);

  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
      const data = records.map(record => ({
        ...record,
        createdBy: `${createdBy[record.createdBy]?.name ?? ""}`,
      }));
      ExcelExport(
        PbhStatusUpdateExcelHeader,
        data.map(v => [
          v.refNo,
          v.previousStatusName,
          v.newStatusName,
          v.createdBy,
          v.createdDate,
          htmlToPlainText(v.remark),
        ]),
        PbhStatusUpdateExcelName
      );
    });
  };

  React.useEffect(() => {
    if (isUploadFileDialogOpen === false) {
      setSelectedItemRequestId(0);
    }
  }, [isUploadFileDialogOpen]);

  const Actions = props => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <FileUploadDialogButton {...props} />
        </ButtonGroup>
      </Box>
    );
  };

  const FileUploadDialogButtonClick = props => {
    setSelectedItemRequestId(props?.record?.requestId);
    handleFileDialogOpen();
  };

  const FileUploadDialogButton = props => {
    return (
      <IconButton
        {...props}
        onClick={() => {
          FileUploadDialogButtonClick(props);
        }}
      >
        <Tooltip title="Upload File">
          <Backup />
        </Tooltip>
      </IconButton>
    );
  };

  return (
    <>
      <PoolList
        {...props}
        bulkActionButtons={false}
        exporter={ExportToExcel}
        title={TitlePbhStatusUpdate.list}
        filters={
          <FilterToolbar
            dataSource={[
              {
                source: "refNo",
                inputType: FilterInputType.Text,
                label: "Ref No",
              },
              {
                source: "previousStatusName",
                inputType: FilterInputType.Text,
                label: "Previous Status",
              },
              {
                source: "newStatusName",
                inputType: FilterInputType.Text,
                label: "New Status",
              },
              {
                source: "remark",
                inputType: FilterInputType.Text,
                label: "Remark",
              },
              // {
              //     source: 'createdDate',
              //     inputType: FilterInputType.Date,
              //     label: 'Created Date From',
              //     filterTypeChangeDisable: true,
              //     filterType: FilterTypes.GreaterThan
              // },
              // {
              //     source: 'createdDate',
              //     inputType: FilterInputType.Date,
              //     label: 'Created Date To',
              //     filterTypeChangeDisable: true,
              //     filterType: FilterTypes.LessThan
              // },
            ]}
          />
        }
      >
        <Datagrid>
          <Actions label="Actions" />
          <TextField source="refNo" />
          <TextField source="previousStatusName" />
          <TextField source="newStatusName" />
          <RichTextField source="remark" fullWidth={true} />
          <CreatedByField source="createdBy" link={false} />
          <CustomDateField source="createdDate" fullWidth={true} showTime />
        </Datagrid>
      </PoolList>

      <Grid>
        <PbhStatusUpdateUploadFile
          open={isUploadFileDialogOpen}
          handleClose={handleFileDialogClose}
          record={{ requestId: selectedItemRequestId }}
        />
      </Grid>
    </>
  );
};

export default PbhStatusUpdateList;
